import React from 'react';


import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../assets/css/student/about/AboutHero.css';


const AboutHero = () => {

  return (
    <section className="ah-hero-section">
      <div className="ah-hero-content">
        <div className="ah-text-content">
          <div className="ah-title-wrapper">
            <h1 className="ah-hero-title">Making Education Accessible </h1>
            <div className="ah-title-underline"></div>
          </div>
          
          <p className="ah-hero-description">
            Education is a fundamental right, but many students face financial barriers that prevent them from pursuing it. Student Support Hub aims to remove these barriers by connecting students in need with donors and NGOs who can provide support for school fees, books, and uniforms. By offering a secure and transparent platform, the project ensures that every contribution reaches the right student, giving them the opportunity to continue their education and achieve their dreams. This way, the project truly makes education accessible to students who might otherwise be left behind.
          </p>

          <button className="ah-cta-button">Read More</button>
        </div>

        <div className="ah-image-content">
          <img 
            src="https://i.pinimg.com/736x/56/50/45/565045bb34ee012a94b2e64af9d87b8a.jpg"
            alt="Child with guitar" 
            className="ah-hero-image"
          />
        </div>
      </div>
    </section>
  );
};

export default AboutHero;